import React, { useEffect, useRef, useState } from "react";

import {
  Badge,
  Button,
  Collapse,
  DatePicker,
  Dropdown,
  Input,
  Modal,
  Segmented,
  Skeleton,
  Table,
  Tag,
  TimePicker,
  Tooltip,
} from "antd";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { GoPlusCircle } from "react-icons/go";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaAnglesRight, FaPrint } from "react-icons/fa6";
import { CiCircleInfo, CiEdit, CiSquareInfo } from "react-icons/ci";
import {
  IoArrowBack,
  IoArrowBackCircleOutline,
  IoCreateOutline,
  IoSettingsOutline,
} from "react-icons/io5";
import { fontSize } from "@mui/system";
import { CiSquarePlus } from "react-icons/ci";
import { PiHamburgerThin } from "react-icons/pi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { SiFsecure } from "react-icons/si";
import dayjs from "dayjs";
import { Space, Switch } from "antd";
import { useMessage } from "../../Components/MessageProvider/MessageProvider";
import axiosInstance from "../../Components/axiosInstance/AxiosInstance";
import { MdDeleteOutline, MdOutlineUnarchive } from "react-icons/md";
import Ticketlar from "./CustomerViews/Ticketlar";
import Yukxatlari from "./CustomerViews/Yukxatlari";
import Dk from "./CustomerViews/Dk";
import moment from "moment";
import { IoMdPerson } from "react-icons/io";
import CustomerEdit from "./CustomerEdit";
// import { Helmet, HelmetProvider } from "react-helmet";
import { HelmetProvider, Helmet } from "react-helmet-async";
import formatNumberWithSpaces from "../../Components/NumberToWords/FormatNumber";
import { LuTimerReset } from "react-icons/lu";
import TextArea from "antd/es/input/TextArea";
import { GrMapLocation } from "react-icons/gr";
// import historyDel from "../../assets/animations/historyDel.json";
import { TbHistoryToggle } from "react-icons/tb";
import Locations from "../../Components/Customers/Locations";
import { OneCustomer } from "../../Stores/Customers/OneCustomer";
import MyTickets from "./CustomerViews/MyTickets/MyTickets";
import SettingsModal from "../../Components/Customers/Settings/SettingsModal";
import { CustomersStore } from "../../Stores/Customers/CustomersStore";

export default function CustomerView() {
  // const { data, loading, error } = CustomersStore();

  const { data, loading, error, fetchData } = OneCustomer();
  const { fetchData: getCustomers } = CustomersStore();
  let navigate = useNavigate();
  let elementRef = useRef();
  let [sections, setSections] = useState(1);
  let [customer, setCustomer] = useState(null);
  let [customerDoc, setCustomerDoc] = useState({});
  let [isModalOpen, setIsModalOpen] = useState(false);
  let [isBelieverModalOpen, setIsBelieverModalOpen] = useState(false);
  let [openTimer, setOpenTimer] = useState(false);
  let [open, setOpen] = useState(false);
  let [openPopup, setOpenPopup] = useState(false);
  let [openLocation, setOpenLocation] = useState(false);
  let [openSettings, setOpenSettings] = useState(false);
  let [SMSAlert, setSMSAlert] = useState(null);

  let [timer, setTimer] = useState(true);
  // let [timer, setTimer] = useState(true);
  let [DKSum, setDKSum] = useState(0);
  const { id } = useParams();

  useEffect(() => {
    setSections("Yuk Xatari");
    if (!loading && !data && !data?.name && !data?.INN && !data?.phone) {
      for (let index = 0; index <= 3; index++) {
        setTimeout(() => {
          fetchData(id);
        }, 3000);
      }
    }
    fetchData(id);
    getCustomers();
  }, [id]);
  useEffect(() => {
    console.log(data);
  }, [data]);

  const handlePrint = () => {
    const printContent = elementRef.current;
    const WinPrint = window.open("", "", "width=900,height=900");
    // WinPrint.document.write("<html><head><title>Print</title>");
    // WinPrint.document.write(
    //   ""
    // );
    // WinPrint.document.write("</head><body>");
    WinPrint.document.write(printContent.innerHTML);
    // WinPrint.document.write("</body></html>");
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  };

  const messageApi = useMessage();

  const customerItems = [
    {
      key: "5",
      // disabled: true,
      label: (
        <div
          className=" block w-[100%] flex items-center justify-start gap-2 "
          rel="noopener noreferrer"
          onClick={() => {
            handlePrint();
          }}
        >
          {/* <Lottie animationData={historyDel} loop={true} /> */}
          <FaPrint className="font-[30px]" />
          Print
        </div>
      ),
    },
    {
      key: "7",
      label: (
        <div
          className="hidden  md:flex block w-[100%] flex items-center justify-start gap-2 "
          rel="noopener noreferrer"
          onClick={() => {
            // delUser();
            setOpenSettings(true);
          }}
        >
          <IoSettingsOutline className="font-[30px]" />
          Sozlamalar
        </div>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "6",
      label: (
        <div
          className=" block w-[100%] flex items-center justify-start gap-2 "
          rel="noopener noreferrer"
          onClick={() => {
            setOpen(true);
          }}
        >
          <CiEdit className="font-[30px]" /> O'zgartirish
        </div>
      ),
    },

    {
      type: "divider",
    },
    {
      key: "3",
      disabled: true,
      label: (
        <div
          className=" block w-[100%] flex items-center justify-start gap-2 "
          rel="noopener noreferrer"
        >
          <GrMapLocation className="font-[30px]" />
          Manzil
        </div>
      ),
    },

    {
      key: "info",
      type: "group",
      label: (
        <div
          className=" block w-[100%] flex items-center justify-start gap-2"
          rel="noopener noreferrer"
        >
          <CiSquareInfo className="font-[30px]" />{" "}
          <span className="text-[13px]">
            Y: {data?.written_by} - {data?.type}
          </span>
        </div>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "info",
      type: "group",
      label: (
        <div
          className=" block w-[100%] flex items-center justify-start gap-2"
          rel="noopener noreferrer"
        >
          <IoCreateOutline className="font-[30px]" />{" "}
          <span className="text-[13px]">
            {data?.updated_at?.split("T")[0]}{" "}
            {data?.updated_at?.split("T")[1]?.split(".")[0]}
          </span>
        </div>
      ),
    },
  ];

  let putUser = async () => {
    try {
      let data = await axiosInstance.put("/api/customers/" + id, {
        date_call: customer?.date_call,
        comment: customer?.comment,
      });
      if (data?.error) {
        messageApi.open({
          type: "error",
          content: data.message,
        });
        return;
      }

      if (data) console.log(data.data);
      setCustomer(data.data.data);
      messageApi.open({
        type: "success",
        content: "Saqlandi!",
      });
      setIsModalOpen(false);
    } catch (error) {
      console.log(error);
    } finally {
      console.log("true");
    }
  };

  let getUserDoc = async () => {
    try {
      let { data } = await axiosInstance.get("/api/customers/list/" + id);

      console.log(data);
      setCustomerDoc(data);
    } catch (error) {
      // messageApi.open({
      //   type: "error",
      //   content: error.response.data.message,
      // });
      console.log(error);
    } finally {
      console.log("true");
    }
  };

  let collapsedItems = [
    {
      key: "1",
      label: "Xisob",
      children: (
        <div className="overflow-auto">
          <div className="container mx-auto p-4">
            <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
              <thead>
                <tr className="bg-gray-100">
                  <th className="text-left px-4 py-2 border-b">Nomi</th>
                  <th className="text-left px-4 py-2 border-b">Nasiya</th>
                  <th className="text-left px-4 py-2 border-b">Naqt</th>
                  <th className="text-left px-4 py-2 border-b">Birja</th>
                </tr>
              </thead>
              <tbody>
                {customerDoc?.nasiya?.map((product, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-gray-50" : "bg-white"
                    } hover:bg-gray-100`}
                  >
                    <td className="px-4 py-2 border-b">{product.name}</td>
                    <td className="px-4 py-2 border-b">
                      {product.total_tonna}
                    </td>
                    <td className="px-4 py-2 border-b">1</td>
                    <td className="px-4 py-2 border-b">20</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ),
    },
  ];

  let windowPopUp = (
    <div>
      <div class="container mx-auto">
        <h2 class="text-xl font-bold" id="dk-value">
          Yukxatlari
        </h2>
        <table class="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
          <thead>
            <tr class="bg-gray-100">
              <th class="text-left px-2 py-2 border-b">Nomi</th>
              <th class="text-left px-2 py-2 border-b">Nasiya</th>
              <th class="text-left px-2 py-2 border-b">Naqt</th>
              <th class="text-left px-2 py-2 border-b">Birja</th>
              <th class="text-left px-2 py-2 border-b">Shaxobcha</th>
            </tr>
          </thead>
          <tbody id="table-content">
            {data?.summary?.map((product, index) => {
              return (
                <tr
                  class={`${
                    index % 2 === 0 ? "bg-gray-50" : "bg-white"
                  } hover:bg-gray-100`}
                >
                  <td class="px-4 py-2 border-b">{product.name}</td>
                  <td class="px-4 py-2 border-b">{product.nasiya}</td>
                  <td class="px-4 py-2 border-b">{product.naqt}</td>
                  <td class="px-4 py-2 border-b">{product.birja}</td>
                  <td class="px-4 py-2 border-b">{product.shaxobcha}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div class="container mx-auto mt-2">
        <h2 class="text-xl font-bold" id="dk-value">
          Tiketlar
        </h2>
        <table class="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
          <thead>
            <tr class="bg-gray-100">
              <th class="text-left px-2 py-2 border-b">Nomi</th>
              <th class="text-left px-2 py-2 border-b">Tn</th>
            </tr>
          </thead>
          <tbody id="table-content">
            {Object.entries(
              data?.ticket_summary ? data?.ticket_summary : {}
            )?.map((product, index) => {
              return (
                <tr
                  class={`${
                    index % 2 === 0 ? "bg-gray-50" : "bg-white"
                  } hover:bg-gray-100`}
                >
                  <td class="px-4 py-2 border-b">{product[0]}</td>
                  <td class="px-4 py-2 border-b">{product[1]}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );

  let customerInfo = !loading ? (
    <div className="max-w-[900px] w-[100%] font-sans">
      <div className="w-[100%] flex flex-row items-center justify-between px-2 py-4 ">
        <div className="flex flex-row gap-1  items-center justify-center">
          <Button
            onClick={() => {
              navigate("/customers");
              console.log("logged");
            }}
            type="link"
            icon={<IoArrowBack />}
          ></Button>
          <h2 className="  mb-0 text-md font-semibold text-s  text-black sm:text-black-900 md:text-2xl dark:sm:text-[#000] text-[#6b7280] flex flex-row items-center gap-1 justify-center">
            <span className=" text-[16px] md:text-[24px]">{data?.name}</span>{" "}
            {data?.verify ? (
              <img
                alt="verify icon"
                src="https://www.notion.so/icons/verified_blue.svg?mode=dark"
                width={25}
                height={25}
              />
            ) : null}
          </h2>
        </div>
        <div>
          <Dropdown
            menu={{
              items: customerItems,
            }}
            placement="topRight"
            arrow
          >
            <Button icon={<HiOutlineDotsVertical />}></Button>
          </Dropdown>
        </div>
        <SettingsModal
          openSettings={openSettings}
          setOpenSettings={setOpenSettings}
        />
      </div>
      <Modal
        style={{ top: "10px", width: "100%" }}
        title="Kirim / Chiqimlar"
        open={openPopup}
        //   loading={loadVagon}
        onOk={() => {
          setOpenPopup(false);
        }}
        onCancel={() => {
          console.log("Modal closed via Cancel button or close icon.");
          setOpenPopup(false);
        }}
        footer={[]}
      >
        <div>{windowPopUp}</div>
      </Modal>
      <Modal
        style={{ top: "10px" }}
        title="Kafilliklar"
        open={isBelieverModalOpen}
        //   loading={loadVagon}
        onOk={() => {
          setIsBelieverModalOpen(false);
        }}
        onCancel={() => {
          console.log("Modal closed via Cancel button or close icon.");
          setIsBelieverModalOpen(false);
        }}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              putUser();
              setTimer(!timer);
            }}
          >
            Saqlash
          </Button>,
        ]}
      >
        <div>
          <ul role="list" class="mt-1 space-y-1">
            <li class="group">
              <a
                class="text-sm/6 text-gray-600 group-last:text-slate-900 hover:text-gray-900 group-last:[&amp;>span]:inline-block group-last:[&amp;>span]:transition hover:group-last:[&amp;>span]:translate-x-0.5"
                href="/components/application-ui/lists/tables"
              >
                12.01.2025 Yukxati:14 kassa:53
              </a>
            </li>
            <li class="group">
              <a
                class="text-sm/6 text-gray-600 group-last:text-slate-900 hover:text-gray-900 group-last:[&amp;>span]:inline-block group-last:[&amp;>span]:transition hover:group-last:[&amp;>span]:translate-x-0.5"
                href="/components/application-ui/lists/feeds"
              >
                {/* Feeds */}
              </a>
            </li>
          </ul>
        </div>
      </Modal>
      {/* timer */}
      <Modal
        style={{ top: "10px" }}
        title="Timer qo'yish"
        open={openTimer}
        //   loading={loadVagon}
        onOk={() => {
          setOpenTimer(false);
        }}
        onCancel={() => {
          console.log("Modal closed via Cancel button or close icon.");
          setOpenTimer(false);
        }}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              // putUser();
              // setTimer(!timer);
            }}
          >
            Saqlash
          </Button>,
        ]}
      >
        <div className="flex flex-col  items-center gap-2 justify-center">
          <DatePicker
            className="w-[100%]"
            showTime
            format="YYYY-MM-DD HH:mm:ss"
            // defaultValue={dayjs()}
            onChange={(value, dateString) => {
              console.log("Selected DateTime (dayjs object):", value);
              console.log("Formatted DateTime (string):", dateString);
              // Save the formatted date-time string
            }}
          />

          <TextArea type="comment" placeholder="Jonatish uchun izox" />
        </div>
      </Modal>
      <dl className="p-0 px-2 mt-0 mb-0  md:text-xs font-medium flex items-center row-start-2 sm:mt-1 sm:row-start-3 md:mt-2.5 lg:row-start-2">
        <dt className="sr-only">{data?.name} raqami</dt>
        <dd className="text-indigo-600 flex items-center dark:text-indigo-400">
          <svg
            width="24"
            height="24"
            fill="none"
            aria-hidden="true"
            className="mr-1 stroke-current dark:stroke-indigo-500"
          >
            <path
              d="m12 5 2 5h5l-4 4 2.103 5L12 16l-5.103 3L9 14l-4-4h5l2-5Z"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
          <span className="text-[14px] md:text-[20px] ">
            TEL: {data?.phone}
            <span className="text-slate-400 font-normal"></span>
          </span>
        </dd>
        <dt className="sr-only">{data?.name} INN:</dt>
        <dd className="flex items-center">
          <svg
            width="2"
            height="2"
            aria-hidden="true"
            fill="currentColor"
            className="mx-3 text-slate-300"
          >
            <circle cx="1" cy="1" r="1"></circle>
          </svg>
          <svg
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className="text-[14px] md:text-[20px] mr-1 text-slate-400 dark:text-slate-500"
            aria-hidden="true"
          >
            <path d="M18 11.034C18 14.897 12 19 12 19s-6-4.103-6-7.966C6 7.655 8.819 5 12 5s6 2.655 6 6.034Z"></path>
            <path d="M14 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"></path>
          </svg>
          <span className="text-[14px] md:text-[20px]">СТИР: {data?.INN}</span>
        </dd>
      </dl>
      <div className="ml-2">
        <dt className="sr-only">Year</dt>
        <dd
          className="px-[30px] text-[#94A3B8] text-[12px] flex flex-row items-center justify-start gap-1"
          style={{ fontSize: "14px" }}
        >
          <Button
            className="hidden"
            size="small"
            icon={<CiCircleInfo />}
            onClick={() => {
              setIsModalOpen(true);
            }}
          ></Button>{" "}
          {/* {moment(data?.date_call ? data?.date_call : null).format(
            "DD.MM.YYYY"
          )}{" "} */}
          {data?.comment}
          {/* {data?.date_call} */}
          <svg
            width="2"
            height="2"
            fill="currentColor"
            className="mx-2 text-slate-300"
            aria-hidden="true"
          >
            <circle cx="1" cy="1" r="1"></circle>
          </svg>
        </dd>
      </div>
      <section className="info">
        <Modal
          style={{ top: "10px" }}
          title="Mahsulot qo'shish"
          open={isModalOpen}
          //   loading={loadVagon}
          onOk={() => {
            setIsModalOpen(false);
          }}
          onCancel={() => {
            console.log("Modal closed via Cancel button or close icon.");
            setIsModalOpen(false);
          }}
          footer={[
            <Button
              key="submit"
              type="primary"
              onClick={() => {
                putUser();
                setTimer(!timer);
              }}
            >
              Saqlash
            </Button>,
          ]}
        >
          <div className="flex flex-row items-center gap-1 justify-start p-2 gap-1">
            <input
              className="p-1 rounded"
              type="date"
              onChange={(e) => {
                setSMSAlert({
                  ...data,
                  date_call: e.target.value,
                });
              }}
              value={data?.date_call?.split("T")[0]}
            />
          </div>
          <Input.TextArea
            className="h-[500px]"
            onChange={(e) => {
              setSMSAlert({
                ...data,
                comment: e.target.value,
              });
            }}
            value={data?.comment}
          />
        </Modal>
      </section>

      <div className="px-2 flex items-center justify-start gap-1">
        <Button
          size="small"
          className=""
          icon={<CiCircleInfo />}
          onClick={() => {
            setOpenPopup(true);
          }}
        ></Button>{" "}
        <div
          editable={true}
          className=" text-xl font-bold m-0 p-0 text-[18px] italic normal"
        >
          DK:{" "}
          <span className="underline text-[17px]">
            {" "}
            {formatNumberWithSpaces(
              (
                data?.akt_sverka_dk?.d?.reduce(
                  (acc, cur) => (acc += cur?.sum),
                  0
                ) -
                data?.akt_sverka_dk?.k?.reduce(
                  (acc, cur) => (acc += cur?.sum),
                  0
                )
              )?.toFixed(2)
            )}{" "}
            SUM
          </span>
        </div>
      </div>
    </div>
  ) : (
    <div className="max-w-[900px] w-[100%] font-sans pt-[30px]">
      <Skeleton active />
    </div>
  );

  return (
    <div className="pb-[100px] w-[100%] scrollbar-hidden">
      <HelmetProvider>
        <Helmet>
          <title>{`${data?.name} No:${data?.id}   ${data?.phone}`}</title>
          <meta
            name="description"
            content={data?.name + "ga yozilgan yukxati"}
          />
          <meta property="og:title" content={data?.name} />
          <meta
            property="og:description"
            content={data?.name + "  " + data?.phone}
          />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>
      </HelmetProvider>

      {/* location */}
      <Locations
        setOpenLocation={setOpenLocation}
        openLocation={openLocation}
      />

      <CustomerEdit setOpen={setOpen} open={open} />
      <div
        ref={elementRef}
        className="flex flex-col gap-1"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {customerInfo}
        <div className="max-w-[500px] flex items-center justify-center gap-1 relative m-auto">
          <Segmented
            size="large"
            options={["Yuk Xatari", "D/K", "TICKETLAR", "RASMIY"]}
            value={sections}
            onChange={(val) => {
              setSections(val);
            }}
            style={{
              transform: "scale(1.2)", // Increase size by 1.2x
              transformOrigin: "center", // Keep it centered
            }}
          />
        </div>
        <div className="overflow-auto max-w-[1200px]  w-[100%] md:w-[90%]">
          {/* yuk xatlari */}
          {sections == "Yuk Xatari" ? <Yukxatlari /> : <div></div>}

          {/* D/K */}
          {sections == "D/K" ? <Dk /> : <div></div>}

          {/* tikcets */}
          {sections == "RASMIY" ? (
            <Ticketlar customerDoc={customerDoc} />
          ) : (
            <div></div>
          )}

          {sections == "TICKETLAR" ? (
            <MyTickets customerDoc={customerDoc} />
          ) : (
            <div></div>
          )}

          {/* YUK KIRIM */}
          {sections == 4 ? (
            <div className=" flex flex-col justify-center">
              <Button
                className="flex-1 my-2"
                onClick={() => {
                  navigate("/checkUser", { replace: true });
                }}
                variant="solid"
                icon={<CiSquarePlus className="font-[30px]" />}
              >
                Yuk kiritish
              </Button>
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                }}
                border="1"
                className="text-[14px]"
                cellpadding="10"
              >
                <tr>
                  <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2">
                    №
                  </th>
                  <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
                    Юк номи
                  </th>
                  <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
                    Соф огирлик
                  </th>
                  <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
                    SHafyor
                  </th>
                  <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
                    Sana
                  </th>
                  <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
                    Izox
                  </th>
                </tr>
                <tr>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"></td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"></td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"></td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"></td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"></td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"></td>
                </tr>
              </table>
            </div>
          ) : (
            <div></div>
          )}
        </div>
        {/* <footer>
          <div
            className="flex items-center justify-between w-[100%]"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <p className="text-[16px] m-0 p-[3px]">Жами миқдори: 0 kg</p>
            <p className="text-[16px] m-0 p-[3px]">50 дона</p>
          </div>
          <div
            className="flex items-center justify-between w-[100%]"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <p className="text-[14px] pt-1">Phone: +998 93 894 40 00</p>
            <p className="text-[14px] pt-1 w-[50%]" style={{ width: "50%" }}>
              Махсулотни ишлаб чиқарувчи томонидан махсус қопларда қадоқанланган
              холда, сон ва сифати жиҳатдан бутлиги ва тўлиқлигини назоратини
              қилган тартибда
            </p>
          </div>
          <div
            className="flex items-center justify-between mt-2"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <p className="text-[16px] m-0 p-[3px]">
              ______________А.Abduvaliev
            </p>
            <p className="text-[16px] m-0 p-[3px]">______________А.Parpiyev</p>
          </div>
        </footer> */}
      </div>
    </div>
  );
}
